import { IInitialFormData, IEditDishContext } from './editDishContext';

export enum EditDishActionTypes {
	REFETCH_DATA = 'REFETCH_DATA',
	SET_INITIAL_FORM_DATA = 'SET_INITIAL_FORM_DATA',
	SET_ALL_DATA = 'SET_ALL_DATA',
	CHANGE_VISIBLE_FORM = 'CHANGE_VISIBLE_FORM',
	SET_FILE_ID = 'SET_FILE_ID',
	DELETE_PHOTO = 'DELETE_PHOTO',
	SET_SMALL_FILE_ID = 'SET_SMALL_FILE_ID',
	DELETE_SMALL_PHOTO = 'DELETE_SMALL_PHOTO',
	SET_VIDEO_FILE_ID = 'SET_VIDEO_FILE_ID',
	DELETE_VIDEO = 'DELETE_VIDEO',
	SET_IS_VIDEO_ACTIVE = 'SET_IS_VIDEO_ACTIVE',
	CHANGE_DISH_NAME = 'CHANGE_DISH_NAME',
	SET_FETCHED_RESTAURANTS = 'SET_FETCHED_RESTAURANTS',
	SET_RESTAURANTS_FOR_PRICE = 'SET_RESTAURANTS_FOR_PRICE',
	CHANGE_PRICE = 'CHANGE_PRICE',
	ADD_PRICE = 'ADD_PRICE',
	REMOVE_PRICE = 'REMOVE_PRICE',
	SET_RESTAURANT_WITH_TURN_OFF_COMMENT = 'SET_RESTAURANT_WITH_TURN_OFF_COMMENT',
	SET_RESTAURANT_WITH_REQUIRED_COMMENT = 'SET_RESTAURANT_WITH_REQUIRED_COMMENT',
	CHANGE_DISH_DESCRIPTION = 'CHANGE_DISH_DESCRIPTION',
	SET_FETCHED_COMBO_MODIFIER = 'SET_FETCHED_COMBO_MODIFIER',
	SET_ID_COMBO_MODIFIER = 'SET_ID_COMBO_MODIFIER',
	SET_DISH_IS_DISABLED = 'SET_DISH_IS_DISABLED',
	SET_DEFAULT_CUSTOMER_LANGUAGE = 'SET_DEFAULT_CUSTOMER_LANGUAGE',
	SET_TRANSLATION_TAB = 'SET_TRANSLATION_TAB',
	CHANGE_TRANSLATION = 'CHANGE_TRANSLATION',
	CHANGE_ACTIVATION_SCHEDULE = 'CHANGE_ACTIVATION_SCHEDULE',
	CHANGE_DEACTIVATION_SCHEDULE = 'CHANGE_DEACTIVATION_SCHEDULE',
	SET_FETCHED_MODIFIER_GROUPS = 'SET_FETCHED_MODIFIER_GROUPS',
	SET_MODIFIER_GROUPS = 'SET_MODIFIER_GROUPS',
	UPDATE_MODIFIER_GROUPS = 'UPDATE_MODIFIER_GROUPS',
	CHANGE_LOWER_LIMIT = 'CHANGE_LOWER_LIMIT',
	CHANGE_UPPER_LIMIT = 'CHANGE_UPPER_LIMIT',
	SET_MODIFIER_GROUPS_AS_ADDITIONAL = 'SET_MODIFIER_GROUPS_AS_ADDITIONAL',
	SET_FETCHED_CATEGORIES = 'SET_FETCHED_CATEGORIES',
	SET_SUGGESTED_DISH_CATEGORY = 'SET_SUGGESTED_DISH_CATEGORY',
	SET_FETCHED_SUGGESTED_DISH_SUB_CATEGORIES = 'SET_FETCHED_SUGGESTED_DISH_SUB_CATEGORIES',
	SET_SUGGESTED_DISH_SUB_CATEGORY = 'SET_SUGGESTED_DISH_SUB_CATEGORY',
	SET_FETCHED_SUGGESTED_DISHES = 'SET_FETCHED_SUGGESTED_DISHES',
	SET_SUGGESTED_DISHES = 'SET_SUGGESTED_DISHES',
	REMOVE_SUGGESTED_DISH = 'REMOVE_SUGGESTED_DISH',
	SET_ADDITIONAL_DISH_CATEGORY = 'SET_ADDITIONAL_DISH_CATEGORY',
	SET_FETCHED_ADDITIONAL_DISH_SUB_CATEGORIES = 'SET_FETCHED_ADDITIONAL_DISH_SUB_CATEGORIES',
	SET_ADDITIONAL_DISH_SUB_CATEGORY = 'SET_ADDITIONAL_DISH_SUB_CATEGORY',
	SET_FETCHED_ADDITIONAL_DISHES = 'SET_FETCHED_ADDITIONAL_DISHES',
	SET_ADDITIONAL_DISHES = 'SET_ADDITIONAL_DISHES',
	REMOVE_ADDITIONAL_DISH = 'REMOVE_ADDITIONAL_DISH',
	SET_DISH_MODIFICATION_CATEGORY = 'SET_DISH_MODIFICATION_CATEGORY',
	SET_FETCHED_DISH_MODIFICATION_SUB_CATEGORIES = 'SET_FETCHED_DISH_MODIFICATION_SUB_CATEGORIES',
	SET_DISH_MODIFICATION_SUB_CATEGORY = 'SET_DISH_MODIFICATION_SUB_CATEGORY',
	SET_FETCHED_DISH_MODIFICATIONS = 'SET_FETCHED_DISH_MODIFICATIONS',
	SET_DISH_MODIFICATIONS = 'SET_DISH_MODIFICATIONS',
	REMOVE_DISH_MODIFICATION = 'REMOVE_DISH_MODIFICATION',
	SET_IDS_SHOW_IN_COMBO_DISHES = 'SET_IDS_SHOW_IN_COMBO_DISHES',
	CHANGE_EXTERNAL_ID = 'CHANGE_EXTERNAL_ID',
	TOGGLE_APPLICABLE_FOR_VAT = 'TOGGLE_APPLICABLE_FOR_VAT',
	CHANGE_TAX_PERCENT = 'CHANGE_TAX_PERCENT',
	TOGGLE_OPEN_PRICE = 'TOGGLE_OPEN_PRICE',
	CHANGE_OPEN_PRICE = 'CHANGE_OPEN_PRICE',
	CHANGE_OPEN_PRICE_MAX_THRESHOLD = 'CHANGE_OPEN_PRICE_MAX_THRESHOLD',
	TOGGLE_FISCALIZED = 'TOGGLE_FISCALIZED',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
	SHOW_ERROR_MODAL_WITH_INFO = 'SHOW_ERROR_MODAL_WITH_INFO',
	RESET_FIELDS = 'RESET_FIELDS',
}

interface IRefetchData {
	type: EditDishActionTypes.REFETCH_DATA;
	payload: {
		needRefetchData: IEditDishContext['needRefetchData'];
	};
}

interface ISetInitialFormData {
	type: EditDishActionTypes.SET_INITIAL_FORM_DATA;
	payload: {
		initialFormData: IInitialFormData;
	};
}

interface ISetAllData {
	type: EditDishActionTypes.SET_ALL_DATA;
	payload: {
		filePath: IEditDishContext['filePath'];
		preSignedUrl: IEditDishContext['preSignedUrl'];
		smallFilePath: IEditDishContext['smallFilePath'];
		smallPreSignedUrl: IEditDishContext['smallPreSignedUrl'];
		videoPath: IEditDishContext['videoPath'];
		videoPreSignedUrl: IEditDishContext['videoPreSignedUrl'];
		isVideoActive: IEditDishContext['isVideoActive'];
		dishId: IEditDishContext['dishId'];
		name: IEditDishContext['name'];
		selectedCustomer: IEditDishContext['selectedCustomer'];
		articleNumber: IEditDishContext['articleNumber'];
		restaurantsForPrice: IEditDishContext['restaurantsForPrice'];
		totalPrices: IEditDishContext['totalPrices'];
		restaurantWithTurnOffComment: IEditDishContext['restaurantWithTurnOffComment'];
		restaurantWithRequiredComment: IEditDishContext['restaurantWithRequiredComment'];
		shortDescription: IEditDishContext['shortDescription'];
		posName: IEditDishContext['posName'];
		isComboDish: IEditDishContext['isComboDish'];
		initialSelectedComboModifier: IEditDishContext['initialSelectedComboModifier'];
		initialCategories: IEditDishContext['initialCategories'];
		initialSubCategories: IEditDishContext['initialSubCategories'];
		externalId: IEditDishContext['externalId'];
		isCreatedInPos: IEditDishContext['isCreatedInPos'];
		isDisabledInRestaurants: IEditDishContext['isDisabledInRestaurants'];
		activationSchedule: IEditDishContext['activationSchedule'];
		deactivationSchedule: IEditDishContext['deactivationSchedule'];
		initialModifierGroups: IEditDishContext['initialModifierGroups'];
		modifierGroupsWithAdditionalData: IEditDishContext['modifierGroupsWithAdditionalData'];
		initialModifierGroupsAsAdditional: IEditDishContext['initialModifierGroupsAsAdditional'];
		selectedSuggestedDishes: IEditDishContext['selectedSuggestedDishes'];
		fetchedSuggestedDishes: IEditDishContext['fetchedSuggestedDishes'];
		selectedAdditionalDishes: IEditDishContext['selectedAdditionalDishes'];
		fetchedAdditionalDishes: IEditDishContext['fetchedAdditionalDishes'];
		selectedDishModifications: IEditDishContext['selectedDishModifications'];
		IDsShowInComboDishes: IEditDishContext['IDsShowInComboDishes'];
		fetchedDishModifications: IEditDishContext['fetchedDishModifications'];
		translations: IEditDishContext['translations'];
		isTaxPercentProtectedFromSync: IEditDishContext['isTaxPercentProtectedFromSync'];
		taxPercent: IEditDishContext['taxPercent'];
		hasOpenPrice: IEditDishContext['hasOpenPrice'];
		openPrice: IEditDishContext['openPrice'];
		openPriceMaxThreshold: IEditDishContext['openPriceMaxThreshold'];
		isFiscalized: IEditDishContext['isFiscalized'];
	};
}

interface IChangeVisibleForm {
	type: EditDishActionTypes.CHANGE_VISIBLE_FORM;
	payload: {
		visibleForm: IEditDishContext['visibleForm'];
	};
}

interface ISetFileId {
	type: EditDishActionTypes.SET_FILE_ID;
	payload: {
		fileId: IEditDishContext['fileId'];
	};
}

interface IDeletePhoto {
	type: EditDishActionTypes.DELETE_PHOTO;
}

interface ISetSmallFileId {
	type: EditDishActionTypes.SET_SMALL_FILE_ID;
	payload: {
		smallFileId: IEditDishContext['smallFileId'];
	};
}

interface IDeleteSmallPhoto {
	type: EditDishActionTypes.DELETE_SMALL_PHOTO;
}

interface ISetVideoFileId {
	type: EditDishActionTypes.SET_VIDEO_FILE_ID;
	payload: {
		videoFileId: IEditDishContext['videoFileId'];
	};
}

interface IDeleteVideo {
	type: EditDishActionTypes.DELETE_VIDEO;
}

interface ISetIsVideoActive {
	type: EditDishActionTypes.SET_IS_VIDEO_ACTIVE;
	payload: {
		isVideoActive: IEditDishContext['isVideoActive'];
	};
}

interface IChangeDishName {
	type: EditDishActionTypes.CHANGE_DISH_NAME;
	payload: {
		name: IEditDishContext['name'];
	};
}

interface ISetFetchedRestaurants {
	type: EditDishActionTypes.SET_FETCHED_RESTAURANTS;
	payload: {
		fetchedRestaurants: IEditDishContext['fetchedRestaurants'];
	};
}

interface ISetRestaurantsForPrice {
	type: EditDishActionTypes.SET_RESTAURANTS_FOR_PRICE;
	payload: {
		restaurantsForPrice: IEditDishContext['restaurantsForPrice'];
	};
}

interface IChangePrice {
	type: EditDishActionTypes.CHANGE_PRICE;
	payload: {
		price: IEditDishContext['price'];
	};
}

interface IAddPrice {
	type: EditDishActionTypes.ADD_PRICE;
	payload: {
		totalPrices: IEditDishContext['totalPrices'];
	};
}

interface IRemovePrice {
	type: EditDishActionTypes.REMOVE_PRICE;
	payload: {
		totalPrices: IEditDishContext['totalPrices'];
		restaurantsForPrice: IEditDishContext['restaurantsForPrice'];
		isDisabledInRestaurants: IEditDishContext['isDisabledInRestaurants'];
		restaurantWithTurnOffComment: IEditDishContext['restaurantWithTurnOffComment'];
		restaurantWithRequiredComment: IEditDishContext['restaurantWithRequiredComment'];
	};
}

interface ISetRestaurantWithTurnOffComment {
	type: EditDishActionTypes.SET_RESTAURANT_WITH_TURN_OFF_COMMENT;
	payload: {
		restaurantWithTurnOffComment: IEditDishContext['restaurantWithTurnOffComment'];
	};
}

interface ISetRestaurantWithRequiredComment {
	type: EditDishActionTypes.SET_RESTAURANT_WITH_REQUIRED_COMMENT;
	payload: {
		restaurantWithRequiredComment: IEditDishContext['restaurantWithRequiredComment'];
	};
}

interface IChangeDishDescription {
	type: EditDishActionTypes.CHANGE_DISH_DESCRIPTION;
	payload: {
		shortDescription: IEditDishContext['shortDescription'];
	};
}

interface ISetFetchedComboModifier {
	type: EditDishActionTypes.SET_FETCHED_COMBO_MODIFIER;
	payload: {
		fetchedComboModifier: IEditDishContext['fetchedComboModifier'];
	};
}

interface ISetIDComboModifier {
	type: EditDishActionTypes.SET_ID_COMBO_MODIFIER;
	payload: {
		selectedComboModifier: IEditDishContext['selectedComboModifier'];
	};
}

interface ISetDishDisabledInRestaurants {
	type: EditDishActionTypes.SET_DISH_IS_DISABLED;
	payload: {
		isDisabledInRestaurants: IEditDishContext['isDisabledInRestaurants'];
	};
}

interface ISetDefaultCustomerLanguage {
	type: EditDishActionTypes.SET_DEFAULT_CUSTOMER_LANGUAGE;
	payload: {
		defaultCustomerLanguage: IEditDishContext['defaultCustomerLanguage'];
	};
}

interface ISetTranslationTab {
	type: EditDishActionTypes.SET_TRANSLATION_TAB;
	payload: {
		selectedTranslationTab: IEditDishContext['selectedTranslationTab'];
	};
}

interface IChangeTranslation {
	type: EditDishActionTypes.CHANGE_TRANSLATION;
	payload: {
		translations: IEditDishContext['translations'];
	};
}

interface IChangeActivationSchedule {
	type: EditDishActionTypes.CHANGE_ACTIVATION_SCHEDULE;
	payload: {
		activationSchedule: IEditDishContext['activationSchedule'];
	};
}

interface IChangeDeactivationSchedule {
	type: EditDishActionTypes.CHANGE_DEACTIVATION_SCHEDULE;
	payload: {
		deactivationSchedule: IEditDishContext['deactivationSchedule'];
	};
}

interface ISetFetchedModifierGroups {
	type: EditDishActionTypes.SET_FETCHED_MODIFIER_GROUPS;
	payload: {
		fetchedModifierGroups: IEditDishContext['fetchedModifierGroups'];
	};
}

interface ISetModifierGroups {
	type: EditDishActionTypes.SET_MODIFIER_GROUPS;
	payload: {
		selectedModifierGroups: IEditDishContext['selectedModifierGroups'];
		modifierGroupsWithAdditionalData: IEditDishContext['modifierGroupsWithAdditionalData'];
		selectedModifierGroupsAsAdditional: IEditDishContext['selectedModifierGroupsAsAdditional'];
	};
}

interface IUpdateModifierGroups {
	type: EditDishActionTypes.UPDATE_MODIFIER_GROUPS;
	payload: {
		modifierGroupsWithAdditionalData: IEditDishContext['modifierGroupsWithAdditionalData'];
	};
}

interface ISetModifierGroupsAsAdditional {
	type: EditDishActionTypes.SET_MODIFIER_GROUPS_AS_ADDITIONAL;
	payload: {
		selectedModifierGroupsAsAdditional: IEditDishContext['selectedModifierGroupsAsAdditional'];
	};
}

interface ISetFetchedCategories {
	type: EditDishActionTypes.SET_FETCHED_CATEGORIES;
	payload: {
		fetchedCategories: IEditDishContext['fetchedCategories'];
	};
}

interface ISetSuggestedDishCategory {
	type: EditDishActionTypes.SET_SUGGESTED_DISH_CATEGORY;
	payload: {
		selectedSuggestedDishCategory: IEditDishContext['selectedSuggestedDishCategory'];
	};
}

interface ISetFetchedSuggestedDishSubCategories {
	type: EditDishActionTypes.SET_FETCHED_SUGGESTED_DISH_SUB_CATEGORIES;
	payload: {
		fetchedSuggestedDishSubCategories: IEditDishContext['fetchedSuggestedDishSubCategories'];
	};
}

interface ISetSuggestedDishSubCategory {
	type: EditDishActionTypes.SET_SUGGESTED_DISH_SUB_CATEGORY;
	payload: {
		selectedSuggestedDishSubCategory: IEditDishContext['selectedSuggestedDishSubCategory'];
	};
}

interface ISetFetchedSuggestedDishes {
	type: EditDishActionTypes.SET_FETCHED_SUGGESTED_DISHES;
	payload: {
		fetchedSuggestedDishes: IEditDishContext['fetchedSuggestedDishes'];
	};
}

interface ISetSuggestedDishes {
	type: EditDishActionTypes.SET_SUGGESTED_DISHES;
	payload: {
		selectedSuggestedDishes: IEditDishContext['selectedSuggestedDishes'];
	};
}

interface IRemoveSuggestedDish {
	type: EditDishActionTypes.REMOVE_SUGGESTED_DISH;
	payload: {
		selectedSuggestedDishes: IEditDishContext['selectedSuggestedDishes'];
	};
}

interface ISetAdditionalDishCategory {
	type: EditDishActionTypes.SET_ADDITIONAL_DISH_CATEGORY;
	payload: {
		selectedAdditionalDishCategory: IEditDishContext['selectedAdditionalDishCategory'];
	};
}

interface ISetFetchedAdditionalDishSubCategories {
	type: EditDishActionTypes.SET_FETCHED_ADDITIONAL_DISH_SUB_CATEGORIES;
	payload: {
		fetchedAdditionalDishSubCategories: IEditDishContext['fetchedAdditionalDishSubCategories'];
	};
}

interface ISetAdditionalDishSubCategory {
	type: EditDishActionTypes.SET_ADDITIONAL_DISH_SUB_CATEGORY;
	payload: {
		selectedAdditionalDishSubCategory: IEditDishContext['selectedAdditionalDishSubCategory'];
	};
}

interface ISetFetchedAdditionalDishes {
	type: EditDishActionTypes.SET_FETCHED_ADDITIONAL_DISHES;
	payload: {
		fetchedAdditionalDishes: IEditDishContext['fetchedAdditionalDishes'];
	};
}

interface ISetAdditionalDishes {
	type: EditDishActionTypes.SET_ADDITIONAL_DISHES;
	payload: {
		selectedAdditionalDishes: IEditDishContext['selectedAdditionalDishes'];
	};
}

interface IRemoveAdditionalDish {
	type: EditDishActionTypes.REMOVE_ADDITIONAL_DISH;
	payload: {
		selectedAdditionalDishes: IEditDishContext['selectedAdditionalDishes'];
	};
}

interface ISetDishModificationCategory {
	type: EditDishActionTypes.SET_DISH_MODIFICATION_CATEGORY;
	payload: {
		selectedDishModificationCategory: IEditDishContext['selectedDishModificationCategory'];
	};
}

interface ISetFetchedDishModificationSubCategories {
	type: EditDishActionTypes.SET_FETCHED_DISH_MODIFICATION_SUB_CATEGORIES;
	payload: {
		fetchedDishModificationSubCategories: IEditDishContext['fetchedDishModificationSubCategories'];
	};
}

interface ISetDishModificationSubCategory {
	type: EditDishActionTypes.SET_DISH_MODIFICATION_SUB_CATEGORY;
	payload: {
		selectedDishModificationSubCategory: IEditDishContext['selectedDishModificationSubCategory'];
	};
}

interface ISetFetchedDishModifications {
	type: EditDishActionTypes.SET_FETCHED_DISH_MODIFICATIONS;
	payload: {
		fetchedDishModifications: IEditDishContext['fetchedDishModifications'];
	};
}

interface ISetDishModification {
	type: EditDishActionTypes.SET_DISH_MODIFICATIONS;
	payload: {
		selectedDishModifications: IEditDishContext['selectedDishModifications'];
	};
}

interface IRemoveDishModification {
	type: EditDishActionTypes.REMOVE_DISH_MODIFICATION;
	payload: {
		selectedDishModifications: IEditDishContext['selectedDishModifications'];
		IDsShowInComboDishes: IEditDishContext['IDsShowInComboDishes'];
	};
}

interface ISetIDsShowInComboDishes {
	type: EditDishActionTypes.SET_IDS_SHOW_IN_COMBO_DISHES;
	payload: {
		IDsShowInComboDishes: IEditDishContext['IDsShowInComboDishes'];
	};
}

interface IChangeExternalId {
	type: EditDishActionTypes.CHANGE_EXTERNAL_ID;
	payload: {
		externalId: IEditDishContext['externalId'];
	};
}

interface IToggleTaxPercentProtectedFromSync {
	type: EditDishActionTypes.TOGGLE_APPLICABLE_FOR_VAT;
	payload: {
		isTaxPercentProtectedFromSync: IEditDishContext['isTaxPercentProtectedFromSync'];
		taxPercent: IEditDishContext['taxPercent'];
	};
}

interface IChangeTaxPercent {
	type: EditDishActionTypes.CHANGE_TAX_PERCENT;
	payload: {
		taxPercent: IEditDishContext['taxPercent'];
	};
}

interface IToggleOpenPrice {
	type: EditDishActionTypes.TOGGLE_OPEN_PRICE;
	payload: {
		hasOpenPrice: IEditDishContext['hasOpenPrice'];
		openPrice: IEditDishContext['openPrice'];
		openPriceMaxThreshold: IEditDishContext['openPriceMaxThreshold'];
	};
}

interface IChangeOpenPrice {
	type: EditDishActionTypes.CHANGE_OPEN_PRICE;
	payload: {
		openPrice: IEditDishContext['openPrice'];
	};
}

interface IChangeOpenPriceMaxThreshold {
	type: EditDishActionTypes.CHANGE_OPEN_PRICE_MAX_THRESHOLD;
	payload: {
		openPriceMaxThreshold: IEditDishContext['openPriceMaxThreshold'];
	};
}

interface IToggleFiscalized {
	type: EditDishActionTypes.TOGGLE_FISCALIZED;
}

interface IChangeTypeOfModalWindow {
	type: EditDishActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: IEditDishContext['typeOfModalWindow'];
	};
}

interface IShowErrorModalWithInfo {
	type: EditDishActionTypes.SHOW_ERROR_MODAL_WITH_INFO;
	payload: {
		errorResponseData: IEditDishContext['errorResponseData'];
	};
}

interface IResetSelectedControls {
	type: EditDishActionTypes.RESET_FIELDS;
}

export type TEditDishAction =
	| IRefetchData
	| ISetInitialFormData
	| ISetAllData
	| IChangeVisibleForm
	| ISetFileId
	| IDeletePhoto
	| ISetSmallFileId
	| IDeleteSmallPhoto
	| ISetVideoFileId
	| IDeleteVideo
	| ISetIsVideoActive
	| IChangeDishName
	| ISetFetchedRestaurants
	| ISetRestaurantsForPrice
	| IChangePrice
	| IAddPrice
	| IRemovePrice
	| ISetRestaurantWithTurnOffComment
	| ISetRestaurantWithRequiredComment
	| IChangeDishDescription
	| ISetFetchedComboModifier
	| ISetIDComboModifier
	| ISetDishDisabledInRestaurants
	| ISetDefaultCustomerLanguage
	| ISetTranslationTab
	| IChangeTranslation
	| IChangeActivationSchedule
	| IChangeDeactivationSchedule
	| ISetFetchedModifierGroups
	| ISetFetchedCategories
	| ISetModifierGroups
	| IUpdateModifierGroups
	| ISetModifierGroupsAsAdditional
	| ISetSuggestedDishCategory
	| ISetFetchedSuggestedDishSubCategories
	| ISetSuggestedDishSubCategory
	| ISetFetchedSuggestedDishes
	| ISetSuggestedDishes
	| IRemoveSuggestedDish
	| ISetAdditionalDishCategory
	| ISetFetchedAdditionalDishSubCategories
	| ISetAdditionalDishSubCategory
	| ISetFetchedAdditionalDishes
	| ISetAdditionalDishes
	| IRemoveAdditionalDish
	| ISetDishModificationCategory
	| ISetFetchedDishModificationSubCategories
	| ISetDishModificationSubCategory
	| ISetFetchedDishModifications
	| ISetDishModification
	| IRemoveDishModification
	| ISetIDsShowInComboDishes
	| IChangeExternalId
	| IToggleTaxPercentProtectedFromSync
	| IChangeTaxPercent
	| IToggleOpenPrice
	| IChangeOpenPrice
	| IChangeOpenPriceMaxThreshold
	| IToggleFiscalized
	| IChangeTypeOfModalWindow
	| IShowErrorModalWithInfo
	| IResetSelectedControls;
